import {observer} from "mobx-react";
import React from "react";
import {FormProps} from "../../core/form/formUtils";
import {Validate} from "../../core/form/validate";
import {MdCheckbox, MdTextField} from "../../core/components/fields/fields";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "../../core/form/closedForm";
import {DefinitionType} from "../../core/form/form";
import {createForm} from "../../core/form/createForm";
import {ProjectVersionMaterial} from "../domain/project/projectVersionMaterialDomain";
import StyledSelect from "../../core/components/fields/styledSelect";
import materialsService from "../service/materialsService";
import {action, observable, reaction} from "mobx";
import {EPDCERTIFICATION, Material} from "../domain/material/materialDomain";
import {ProjectVersion} from "../domain/project/projectVersionDomain";
import {loc} from "../../core/common/config/locales";
import {optionsSearch} from "../../core/common/service/commonDataService";
import {
  MATERIAL_ENTITY,
  MATERIAL_USAGE_GROUP_ENTITY
} from "../entityConstants";
import {LovItem} from "../../core/metamodel/mdEntity";


@observer
class ProjectVersionMaterialForm extends React.Component<FormProps<ProjectVersionMaterial, ProjectVersionMaterial>, undefined> {

  // @observable custom : boolean = false;
  //
  // constructor(props: FormProps<ProjectVersionMaterial, ProjectVersion>, context: any) {
  //   super(props, context);
  //
  //   reaction(
  //     () => this.props.dataObject.woodBased,
  //     woodBased => {
  //       const form = props.dataObject.getForm(ProjectVersionMaterialFormDefinition.formName);
  //       if (woodBased) {
  //         props.dataObject.epdcertification = {label: "Certifikát není", value: EPDCERTIFICATION.NO_CERTIFICATION};
  //         props.dataObject.epdCertificationWeight = undefined;
  //         form.updateFieldsPropValue(props.dataObject, 'epdcertification', 'epdCertificationWeight');
  //       }
  //       else {
  //         props.dataObject.fscRequestWeight = undefined;
  //         props.dataObject.fscCertificationWeight = undefined;
  //         props.dataObject.pefcRequestWeight = undefined;
  //         props.dataObject.pefcCertificationWeight = undefined;
  //         form.updateFieldsPropValue(props.dataObject, 'fscRequestWeight', 'fscCertificationWeight', 'pefcRequestWeight', 'pefcCertificationWeight');
  //       }
  //     }
  //   );
  //
  //   reaction(
  //     () => this.props.dataObject.epdcertification,
  //     epdcertification => {
  //       const form = props.dataObject.getForm(ProjectVersionMaterialFormDefinition.formName);
  //       if (epdcertification && epdcertification.value !== EPDCERTIFICATION.NO_CERTIFICATION) {
  //         props.dataObject.woodBased = false;
  //         props.dataObject.pefcCertificationWeight = undefined;
  //         props.dataObject.pefcRequestWeight = undefined;
  //         props.dataObject.fscCertificationWeight = undefined;
  //         props.dataObject.fscRequestWeight = undefined;
  //         form.updateFieldsPropValue(props.dataObject, 'epdcertification', 'epdCertificationWeight');
  //       }
  //     }
  //   );
  //
  // }
  //
  // @action onChangeCustom = (event: React.MouseEvent<{}>, checked: boolean) => {
  //   let {dataObject} = this.props;
  //   this.custom = checked;
  //
  //   if (checked === false) {
  //     this.fillFieldsFromOriginal(dataObject.originalMaterial);
  //   }
  // };
  //
  // @action onChangeOriginal = (e) => {
  //   let {dataObject} = this.props;
  //   let form = dataObject.getForm(ProjectVersionMaterialFormDefinition.formName);
  //   form.getField("originalMaterial").props.onChange(e);
  //   this.fillFieldsFromOriginal(dataObject.originalMaterial);
  // };
  //
  // @action onChangeUsageGroup = (e) => {
  //   let {dataObject} = this.props;
  //   let form = dataObject.getForm(ProjectVersionMaterialFormDefinition.formName);
  //   form.getField("materialUsageGroup").props.onChange(e)
  // };
  //
  //
  // fillFieldsFromOriginal = (original : LovItem<Material>) => {
  //   let {dataObject} = this.props;
  //
  //   if (!original) {
  //     return;
  //   }
  //
  //   materialsService.getMaterialById(Number(original.value)).then(
  //     response => {
  //       const originalMaterial = response;
  //       if (originalMaterial) {
  //         dataObject.code = originalMaterial.code;
  //         dataObject.name = originalMaterial.name;
  //         dataObject.density = originalMaterial.density;
  //         dataObject.thermalCoefficient = originalMaterial.thermalCoefficient;
  //         dataObject.primaryEnergy = originalMaterial.primaryEnergy;
  //         dataObject.co2Equivalent = originalMaterial.co2Equivalent;
  //         dataObject.so2Equivalent = originalMaterial.so2Equivalent;
  //         dataObject.po4Equivalent = originalMaterial.po4Equivalent;
  //         dataObject.r11Equivalent = originalMaterial.r11Equivalent;
  //         dataObject.c2h4Equivalent = originalMaterial.c2h4Equivalent;
  //         dataObject.healthSafetyRequirement = originalMaterial.healthSafetyRequirement;
  //         dataObject.epdcertification = originalMaterial.epdcertification;
  //
  //         const form = dataObject.getForm(ProjectVersionMaterialFormDefinition.formName);
  //         form.updateFieldsPropValue(dataObject, "code", "name", "density", "thermalCoefficient",
  //           "primaryEnergy", "co2Equivalent", "so2Equivalent", "po4Equivalent", "r11Equivalent", "c2h4Equivalent", "healthSafetyRequirement", "epdcertification");
  //       }
  //     }
  //   );
  // };


  render() {
    let {dataObject} = this.props;
    let fields = dataObject.getFormFields(ProjectVersionMaterialFormDefinition.formName);
    let {  name, materialUsageGroup,mass} = fields;


    return (
      <div>

        <div className="row">
          <div className="fx col-xs-4 col-sm-4">
            <MdTextField {...name.props}/>
          </div>
          <div className="fx col-xs-6 col-sm-6">
            <StyledSelect {...materialUsageGroup.props}/>
          </div>
          <div className="fx col-xs-2 col-sm-2">
            <MdTextField {...mass.props}/>
          </div>
        </div>

      </div>
    );
  }
}



export const ProjectVersionMaterialFormDefinition: DefinitionType = {
  formName: 'ProjectVersionMaterialForm',
  fields: [
    {name: 'name',validators: ['IsRequired']},
    {name: 'materialUsageGroup',validators: ['IsRequired']},
    {name: 'mass',validators: ['IsRequired', 'IsNumber']},
  ]
};

export default createForm(ProjectVersionMaterialFormDefinition, null)(ProjectVersionMaterialForm);



// WEBPACK FOOTER //
// ./src/sbtool/component/projectVersionMaterialForm.tsx